import { queryOrThrow, waitFor } from "@rootreeweb/js-lib";

/** The query parameter used to pre-select the prize in the form. */
const QUERY_ARG = "prize";
/**
 * The slugs passed to the page and their corresponding prize names. These are
 * used to pre-select the prize in the form.
 */
const SELECT_OPTIONS = {
	"brand-refresh": "Packaging Power-Up",
	connected: "Connected Packaging Upgrade",
	"power-up": "Packaging Power-Up",
	retreat: "The Rootree Retreat",
	"social-campaign": "SuperMarketerStorytelling",
	storytelling: "SuperMarketerStorytelling",
};
type PrizeKey = keyof typeof SELECT_OPTIONS;

/**
 * CSS selector matching the prize-selection field, via the stable class set on
 * it in the Ninja Form config.
 */
const FIELD_SELECTOR = "select.rt-foundation-prize-select";

/** Initializes extra functionality for the RT Foundation submission form. */
export default function (): void {
	const searchParams = new URLSearchParams(window.location.search);
	const prizeSlug = searchParams.get(QUERY_ARG);
	if (!isPrizeSlug(prizeSlug)) return;

	const isAttached = waitFor(
		".nf-form-cont",
		FIELD_SELECTOR,
		() => {
			setPrize(prizeSlug);
		},
		false,
	);
	if (isAttached === false) {
		console.error("Failed to attach observer.");
	}
}

/**
 * Determine if the set slug is a valid prize key.
 *
 * @param value The value to check.
 * @returns True if valid.
 */
function isPrizeSlug(value: unknown): value is PrizeKey {
	return !!(value && typeof value === "string" && value in SELECT_OPTIONS);
}

/**
 * Sets and then hides the pre-selected prize field.
 *
 * @param prizeSlug The pre-selected prize's slug.
 * @throws {TypeError} If the field row can't be obtained.
 */
function setPrize(prizeSlug: PrizeKey): void {
	const field = queryOrThrow(FIELD_SELECTOR, HTMLSelectElement);
	const wrapper = field.closest(".nf-row");
	if (!(wrapper instanceof HTMLDivElement)) {
		throw new TypeError(`Couldn't get wrapper for ${field.id}`);
	}

	// eslint-disable-next-line security/detect-object-injection
	field.value = SELECT_OPTIONS[prizeSlug];
	const event = new Event("change", { bubbles: true });
	field.dispatchEvent(event);
	wrapper.style.display = "none";
}
